import * as React from "react";
import { cn } from "@/lib/utils";

export interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  dark?: boolean;
  tone?: "paper" | "raised" | "dark";
  as?: "section" | "div" | "footer" | "header";
  /**
   * Opt out of `content-visibility: auto`. Set on anything that is above the
   * fold (the hero) so the browser never defers the LCP paint.
   */
  eager?: boolean;
}

export function Section({
  dark = false,
  tone = "paper",
  as: Comp = "section",
  eager = false,
  className,
  children,
  ...props
}: SectionProps) {
  const resolvedTone = dark ? "dark" : tone;

  return (
    <Comp
      data-canvas={resolvedTone === "dark" ? "dark" : "light"}
      className={cn(
        "w-full",
        !eager && "cv-auto",
        resolvedTone === "dark" && "dark relative bg-ink-900 text-paper-0",
        resolvedTone === "raised" && "bg-paper-100 text-ink-900",
        resolvedTone === "paper" && "bg-paper-50 text-ink-900",
        className,
      )}
      style={{ paddingBlock: "clamp(72px, 9vw, 136px)" }}
      {...props}
    >
      {children}
    </Comp>
  );
}

export default Section;
